import React, { useEffect } from "react";
import "./PreschoolDashboard.css";

const PreschoolDashboard = ({ token, clientId, roleId, onNavigate }) => {
  const isStudent = String(roleId) === "3";

  // Automatically jump to the first game/module if logged in as a student
  useEffect(() => {
    if (isStudent && onNavigate) {
      onNavigate("sketchgame"); // Directs student straight to the first learning module
    }
  }, [isStudent, onNavigate]);

  // If student role, render a clean blank/loading view while it redirects instantly
  if (isStudent) {
    return (
      <div className="dashboard-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <p style={{ color: "#6B7280", fontSize: "1.1rem", fontWeight: "500" }}>Loading your learning adventure...</p>
      </div>
    );
  }

  // Regular Admin / Teacher Dashboard View Below...
  const stats = [
    {
      title: "Total Students",
      value: "128",
      subtext: "12 Active Batches",
      color: "#3182ce",
      bg: "#ebf8ff",
    },
    {
      title: "Today's Attendance",
      value: "94%",
      subtext: "120 Present / 8 Absent",
      color: "#38a169",
      bg: "#f0fff4",
    },
    {
      title: "Fee Collection",
      value: "₹2,45,000",
      subtext: "82% Paid for this term",
      color: "#dd6b20",
      bg: "#fffaf0",
    },
    {
      title: "Pending Enquiries",
      value: "14",
      subtext: "5 Follow-ups today",
      color: "#805ad5",
      bg: "#faf5ff",
    },
  ];

  return (
    <div className="dashboard-container">
      <div className="welcome-banner">
        <h2>Welcome to Admin Dashboard</h2>
        <p>Overview of daily preschool operations, metrics, and actions.</p>
      </div>

      <div className="stats-grid">
        {stats.map((stat, idx) => (
          <div key={idx} className="stat-card">
            <div className="stat-info">
              <span className="stat-title">{stat.title}</span>
              <h3 className="stat-value">{stat.value}</h3>
              <span className="stat-subtext">{stat.subtext}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreschoolDashboard;